import React, { useState } from "react";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close"; // Import CloseIcon
import "./NavBar.css";
import { useMediaQuery } from "@mui/material";
import { Link } from "react-router-dom";

const NavBar = () => {
  const [showMenu, setShowMenu] = useState(false);

  const handleMenuToggle = () => {
    setShowMenu(!showMenu);
  };

  const handleCloseMenu = () => {
    setShowMenu(false);
  };
  const isMobile = useMediaQuery("(max-width: 781px)");
  return (
    <nav className="navbar navbar-inverse">
      {isMobile && (
        <IconButton
          style={{ marginLeft: "5%" }}
          edge="start"
          color="inherit"
          aria-label="menu"
          onClick={handleMenuToggle}
          className={`navbar-menu-icon ${isMobile && showMenu ? "show" : ""}`}
        >
          {showMenu ? <CloseIcon /> : <MenuIcon />}
        </IconButton>
      )}

      <ul className={`nav navbar-nav ${showMenu ? "show" : ""}`}>
        <li>
          <Link to="/medicine" onClick={handleCloseMenu}>
            Medicines
          </Link>
        </li>
        <li>
          <Link to="/personal-care" onClick={handleCloseMenu}>
            Personal Care
          </Link>
        </li>
        <li>
          <Link to="/BabyCare">
            <a onClick={handleCloseMenu}>
              Baby Care
            </a>
          </Link>
        </li>
        <li>
          <Link to="/Lifestyle">
            <a onClick={handleCloseMenu}>
              Lifestyle & Fitness
            </a>
          </Link>
        </li>
        <li>
          <Link to="/Organic">
            <a onClick={handleCloseMenu}>
              Organic
            </a>
          </Link>
        </li>
        <li>
          <Link to="/Healthcare">
            <a onClick={handleCloseMenu}>
              Healthcare Devices
            </a>
          </Link>
        </li>
        {/* <li>
          <Link to="/TrackOrder">
            <a onClick={handleCloseMenu}>
              Track Order
            </a>
          </Link>
        </li> */}
        <li>
          <Link to="/Offers">
            <a onClick={handleCloseMenu}>
              Offers
            </a>
          </Link>
        </li>
        <li>
          <Link to="/DawaiPlus">
            <a onClick={handleCloseMenu}>
              Dawaai Plus
            </a>
          </Link>
        </li>
        <li>
          <Link to="/AsaanOrder">
            <a onClick={handleCloseMenu}>
              Asaan Order
            </a>
          </Link>
        </li>
      </ul>
    </nav>
  );
};

export default NavBar;
